export const MerchantSelectionFormUat = {
  merchantNameInput: 'merchantSelection.merchantName.input',
}
